<template>
    <main class="main producers">
        <div class="container">
            <header-tabs :content="headerTabs" :activeTab="activeTab" />
            <div class="row">
                <div class="col-12">
                    <div class="c-page-headline">
                        <h1 class="c-page-headline__title">Organizatorzy</h1>

                        <div
                            class="c-settings-count"
                            v-if="companiesStatus === 'idle'"
                        >
                            <span>{{
                                pagination.totalRecords
                                    | plurals('wynik', 'wyniki', 'wyników')
                            }}</span>
                        </div>
                    </div>
                    <div class="c-settings" v-if="companiesStatus === 'idle'">
                        <div
                            class="c-settings-filters mt-2 mt-md-0"
                            :class="{
                                'inactive-filters-wrapper': isLotteryUser
                            }"
                        >
                            <div
                                class="d-block mr-auto"
                                :class="{
                                    'inactive-filter': isLotteryUser
                                }"
                            >
                                <sort-component
                                    :text="'Sortuj po:'"
                                    :moduleName="'companies'"
                                    :options="
                                        $store.getters.getCompaniesSortOptions
                                    "
                                ></sort-component>
                            </div>
                            <div
                                class="d-block ml-3"
                                :class="{
                                    'inactive-filter': isLotteryUser
                                }"
                            >
                                <results-per-page
                                    :per-page="pagination.perPage"
                                    :text="'Pokazuj na stronie:'"
                                    :on-change="changeResultsPerPage"
                                    :options="[9, 15, 30]"
                                ></results-per-page>
                            </div>
                        </div>
                    </div>
                    <lottery-info-container
                        class="px-1 py-3"
                        fontBig
                        clickable
                        multiple
                    />
                    <div class="content">
                        <section class="producers">
                            <page-preloader
                                v-if="companiesStatus === 'loading'"
                            ></page-preloader>
                            <div
                                v-else
                                class="
                                    row
                                    mt-n4
                                    row-cols-1 row-cols-sm-2 row-cols-lg-3
                                "
                            >
                                <producer-preview
                                    v-for="producer in producers"
                                    :data="producer"
                                    :key="producer.id"
                                />
                            </div>
                        </section>
                    </div>
                    <div :class="{ 'inactive-filters-wrapper': isLotteryUser }">
                        <the-pagination
                            v-if="
                                pagination &&
                                    pagination.page <= pagination.totalPages
                            "
                            :current="pagination.page"
                            :total="pagination.totalPages"
                            :perPage="pagination.perPage"
                            :on-change="onChange"
                            :class="{ 'inactive-filter': isLotteryUser }"
                        >
                            <results-per-page
                                :per-page="pagination.perPage"
                                :text="'Pokazuj na stronie:'"
                                :on-change="changeResultsPerPage"
                                :class="{
                                    'inactive-filter': isLotteryUser
                                }"
                            ></results-per-page>
                        </the-pagination>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import ProducerPreview from '@/components/producers/ProducerPreview.vue'
import LotteryInfoContainer from '@/components/lottery/LotteryInfoContainer.vue'

export default {
    data() {
        return {
            headerTabs: [
                {
                    text: 'Organizatorzy',
                    hash: '#all'
                },
                {
                    text: 'Twoi organizatorzy',
                    hash: '#yours',
                    disabled: true
                }
            ]
        }
    },
    components: {
        ProducerPreview,
        LotteryInfoContainer
    },
    computed: {
        isLotteryUser() {
            return this.$store.getters.isLotteryUser
        },
        producers() {
            return this.$store.getters.getCompanies
        },
        activeTab: {
            get() {
                return this.$store.getters.getCompaniesActiveTab
            },
            set(value) {
                this.$store.dispatch('setCompaniesActiveTab', value)
            }
        },
        companiesStatus() {
            return this.$store.getters.getCompaniesStatus
        },
        pagination() {
            return this.$store.getters.getCompaniesPagination
        }
    },
    methods: {
        fetch() {
            this.$store.dispatch('companiesFetch')
        },
        changeResultsPerPage(value) {
            return this.$router.push({
                query: { ...this.$route.query, show: value, page: 1 }
            })
        },
        onChange(page) {
            return this.$router.push({
                query: { ...this.$route.query, page: page }
            })
        }
    },
    created() {
        if (this.$route.hash) {
            const findTab = this.headerTabs.findIndex(
                el => el.hash === this.$route.hash
            )
            if (findTab) this.activeTab = findTab
        }
        this.fetch()
    }
}
</script>
